export const isPromise = <T>(value: T | Promise<T>): value is Promise<T> => {
  return value instanceof Promise
}
